import { ImageLoaderProps } from 'next/legacy/image';

export const defaultImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=';

export const loader = ({ src, width, quality = 75 }: ImageLoaderProps) => {
  let url = src
    .replace('la-fourche.cdn.prismic.io/la-fourche/', 'cms-cdn.lafourche.fr/')
    .replace('images.prismic.io/la-fourche/', 'cms-cdn.lafourche.fr/')
    .replace('prismic-io.s3.amazonaws.com/la-fourche/', 'cms-cdn.lafourche.fr/')
    .replace('cdn.shopify.com', 'assets.lafourche.fr');

  if (url.includes('auto=compress')) {
    try {
      const urlObject = new URL(url);

      urlObject.searchParams.delete('auto');
      url = urlObject.href;
    } catch (e) {
      console.error(e);
    }
  }

  return `${url}${url.includes('?') ? '&' : '?'}width=${
    width || 'auto'
  }&quality=${quality}`;
};
